const OrderAliasButton = ({ aliasAdded, disabled, onClick }) => (
  <button
    className={`btn btn-secondary transactions-alias-button${aliasAdded ? ' transactions-alias-button-added' : ''}`}
    type="button"
    onClick={onClick}
    disabled={aliasAdded || disabled}
  >
    {aliasAdded ? 'Alias Added' : 'Add Type Alias'}
  </button>
);

export default OrderAliasButton;
